// https://joyspace.jd.com/h/personal/pages/iAvHwwAKMorMl3iJTdFL
'use client';

import { useParams, usePathname } from 'next/navigation';
import { useEffect } from 'react';

const SetupLandingPage = () => {
  const pathname = usePathname();
  const isMiniHome = pathname.startsWith('/minihome');
  const params = useParams();

  useEffect(() => {
    // 获取当前完整URL
    const currentUrl = new URL(window.location.href);
    const { pathname } = currentUrl;
    // 仅在路径包含 /landingPage 前缀时执行替换,并删除前缀
    if (pathname.startsWith('/landingPage')) {
      // 移除 /landingPage 前缀
      const newPath = pathname.replace('/landingPage', '') || '/';

      // 保留查询参数（search 包含 ? 及后续参数）
      const newUrl = newPath + currentUrl.search;
      history.replaceState(null, '', newUrl);
    }
  }, [pathname, isMiniHome, params]);
  return <></>;
};
export default SetupLandingPage;
